
import axios from "../api/axios";


const register = (registerData) => {
  return axios.post("/api/auth/signup", registerData, {
    withCredentials: true   // required if your backend uses cookies/CSRF
  });
};

const login = (email, password) => {
  return axios.post("/api/auth/login", {
    email,
    password
  }, {
    withCredentials: true
  });
};


const AuthService = {
  register,
  login
};

export default AuthService;